import { Box, SideSheet, SideSheetSize, Spinner, SpinnerSize, Text, useSideSheetState } from '@bechtel/gds';
import { useAppUser, useSearchProjectConfiguration } from '@bechtel/ht-clients-common';
import { OperatorType, ProjectConfiguration } from '@bechtel/ht-types';
import { get, map } from 'lodash';
import { FC, useEffect } from 'react';
import { ErrorBoundary } from '~/components';
import { NavLinkStyled } from '../../list/styled';
import NewConfiguration from '../configuration';
import {
  NewConfigurationItemStyled,
  ProjectConfigurationListContainerStyled,
  ProjectConfigurationName,
} from './styled';
export interface ProjectConfigurationProps {
  handleClick: (selectedItem: ProjectConfiguration) => void;
}
export const ProjectConfigurationList: FC<ProjectConfigurationProps> = ({ handleClick }) => {
  const { visible: visibleNewItem, open: openNewItem, close } = useSideSheetState(false);

  const {
    searchProjectConfiguration,
    data: projectConfigurationList,
    loading: dataLoading,
  } = useSearchProjectConfiguration();
  const { appUser } = useAppUser();

  const configurationList = get(projectConfigurationList, 'searchProjectConfigurations.items', []);
  useEffect(() => {
    searchProjectConfiguration({
      sortInput: [],
      filterInput: {
        and: [
          {
            field: 'projectId',
            operator: OperatorType.EQUAL,
            value: appUser?.defaultProject?.id,
          },
        ],
      },
    });
  }, [appUser?.defaultProject?.id, searchProjectConfiguration]);
  return (
    <Box css={{ position: 'relative' }}>
      {dataLoading && (
        <Box alignItems={{ sm: 'center' }} justifyContent={{ sm: 'center' }} style={{ width: '316px' }}>
          <Spinner size={SpinnerSize.LARGE} />{' '}
        </Box>
      )}
      {!dataLoading && (
        <ProjectConfigurationListContainerStyled>
          {map(configurationList, (configItem: ProjectConfiguration) => {
            const encodedId = encodeURIComponent(configItem.id);

            return (
              <NavLinkStyled
                data-testid={`user-list-item-${encodedId}`}
                to={`/project-admin/project-admin/configurationid/${encodedId}`}
                key={encodedId}
                onClick={() => {
                  handleClick(configItem);
                }}
              >
                <ProjectConfigurationName>
                  <Text size="400" color="primary.700" weight="600">
                    {configItem.configurationName.toLocaleUpperCase()}{' '}
                  </Text>
                </ProjectConfigurationName>
              </NavLinkStyled>
            );
          })}
          <NavLinkStyled
            data-testid={`user-list-item-1`}
            to={`/project-admin/project-admin/configurationid/`}
            key="{encodedId}"
            onClick={() => {
              openNewItem();
            }}
            style={{ position: 'absolute', bottom: '12px' }}
          >
            <NewConfigurationItemStyled>
              <Text size="400" color="primary.700" weight="600">
                New Configuration
              </Text>
            </NewConfigurationItemStyled>
          </NavLinkStyled>
        </ProjectConfigurationListContainerStyled>
      )}

      <ErrorBoundary>
        <SideSheet visible={visibleNewItem} size={SideSheetSize.DEFAULT} style={{ width: '35%' }}>
          <NewConfiguration onClose={close}></NewConfiguration>
        </SideSheet>
      </ErrorBoundary>
    </Box>
  );
};
